// extracted by mini-css-extract-plugin
export default {"description":"ForgotPasswordModal_description__Ntsas","button":"ForgotPasswordModal_button__CQGC8"};